import NotFoundPage from '@/pages/not-found.page';
import { useLocation } from '@/services/router/compat';
import { designStudioDashboardUrl } from '@/services/router/design-studio-href';
import { SafeNavigate } from '@/services/router/safe-navigate';

// `/workspaces/:id/design-studio/*`: the editor's pages are hydra routes (`-design-studio-routes`), so only
// Design Studio URLs with no page land here.
export default function DesignStudioPage() {
  return <DesignStudioInHydraFallback />;
}

/** `/design-studio` itself redirects to the dashboard; any other URL with no page gets the not-found page. */
function DesignStudioInHydraFallback() {
  const { pathname } = useLocation();
  const workspaceId = DESIGN_STUDIO_INDEX.exec(pathname)?.[1];
  if (workspaceId !== undefined) {
    return <SafeNavigate to={designStudioDashboardUrl(workspaceId)} options={{ shouldReplaceHistoryEntry: true }} />;
  }
  return <NotFoundPage />;
}

const DESIGN_STUDIO_INDEX = /^\/workspaces\/([^/]+)\/design-studio\/?$/;
